import React from "react";

interface Props {
  children: React.ReactNode;
}

export default function MobileNavbarWrapper({ children }: Readonly<Props>) {
  return <div className="p-2 ps-4">{children}</div>;
}
